(() => {
  const params = new URLSearchParams(location.search);
  const clean = value => (value || '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 80);
  const source = params.get('ref') === 'novadis' ? 'novadis' : 'novarail';
  const placement = clean(params.get('placement')) || 'direkt';
  const track = (event, detail) => {
    document.dispatchEvent(new CustomEvent('novarail:brand-interaction', {detail: {event, ...detail}}));
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event, source_brand: 'novarail', ...detail});
    }
  };
  document.querySelectorAll('[data-brand-source]').forEach(input => { input.value = source.toUpperCase() + ' / ' + placement; });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let url;
    try { url = new URL(link.href); } catch (_) { return; }
    if (['novadis.design', 'www.novadis.design'].includes(url.hostname)) {
      track('brand_referral_click', {target_brand: 'novadis', placement: clean(link.dataset.brandPlacement || url.searchParams.get('placement')) || 'inhalt', destination_path: url.pathname});
    } else if (link.dataset.brandAction === 'light-planning') {
      track('planning_request_click', {placement: clean(link.dataset.brandPlacement)});
    }
  });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        track('brand_module_view', {target_brand: 'novadis', placement: clean(entry.target.dataset.brandModule)});
        observer.unobserve(entry.target);
      });
    }, {threshold: 0.15});
    document.querySelectorAll('[data-brand-module]').forEach(root => observer.observe(root));
  }
  if (document.querySelector('[data-contact-success]')) track('generate_lead', {lead_type: 'contact', referral_brand: source, placement});
})();
